module.exports = __webpack_public_path__ + "static/media/AboutIcon03.2e955ff4.png";